import { TIER_COLORS, tierPerks } from "@/lib/api";

export default function Avatar({ src, level, tier, size = 44, className = "" }) {
  const ring = tier ? TIER_COLORS[tier] : "#7C3AED";
  const royal = tier ? tierPerks(tier).royal_frame : false;
  return (
    <div className={`relative inline-block shrink-0 ${className}`} style={{ width: size, height: size }}>
      <div
        className="rounded-full p-[2px] w-full h-full"
        style={{ background: tier ? `linear-gradient(135deg, ${ring}, #EC4899)` : "linear-gradient(135deg,#7C3AED,#EC4899)", boxShadow: royal ? `0 0 12px ${ring}` : "none" }}
      >
        <img
          src={src || "https://i.pravatar.cc/300?u=guest"}
          alt=""
          className="w-full h-full rounded-full object-cover border-2 border-[#0B0F19]"
        />
      </div>
      {royal && (
        <span className="absolute -top-2 left-1/2 -translate-x-1/2 leading-none" style={{ fontSize: size * 0.32 }}>👑</span>
      )}
      {level ? (
        <span
          className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[9px] font-bold px-1.5 rounded-full text-black leading-[14px]"
          style={{ background: ring }}
        >
          {level}
        </span>
      ) : null}
    </div>
  );
}
